import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getCellClassName, getContainerStyle } from './util';

class GridGroup extends Component {
    static defaultProps = {
        rowGap: 16,
        colGap: 16,
        columnSpan: 3,
        rowSpan: 1,
        offsetColumn: 0,
    };

    render() {
        const {
            className,
            style,
            children,
            colGap,
            rowGap,
            rowSpan,
            columnSpan,
            offsetColumn,
            ...restProps
        } = this.props;

        const wrapCls = classnames("grid-layout-container", "grid-cell", className, ...getCellClassName(rowSpan, columnSpan, offsetColumn));
        const wrapStyle = Object.assign({}, getContainerStyle(rowGap, colGap), style);
        return (
            <div className={wrapCls} style={wrapStyle} {...restProps}>
                {children}
            </div>
        );
    }
}

GridGroup.propTypes = {
    style: PropTypes.object,
    className: PropTypes.string,
    colGap: PropTypes.number,
    rowGap: PropTypes.number,
    offsetColumn: PropTypes.number,
    columnSpan: PropTypes.number,
    rowSpan: PropTypes.number,
};

export default GridGroup;  